import { SearchIcon } from 'lucide-react';

import { Card } from '@/components/ui/card';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';

import OrderRow from './OrderRow';

import { useOrders } from '@/data/order';

const OrderList = () => {
  const orders = useOrders();

  if (orders.data.query.length === 0) {
    return (
      <Empty>
        <EmptyIcon>
          <SearchIcon />
        </EmptyIcon>
        <EmptyTitle>No Orders Found</EmptyTitle>
        <EmptyDescription>Try adding an activity</EmptyDescription>
      </Empty>
    );
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Order Num</TableHead>
              <TableHead>Customer</TableHead>
              <TableHead className="text-right">Total</TableHead>
              <TableHead>Purchase Date</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders.data.query.map((orderId) => (
              <OrderRow key={orderId} orderId={orderId} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {orders.data.query.length}
        </span>
      </div>
    </>
  );
};

export default OrderList;
